module.exports = __webpack_public_path__ + "img/kuber.44045ee.svg";